import React from "react";
import "./style.css";

/* Legacy shared button, restyled to the redesign tokens (§2.7): the old
   navy-with-white-fold gradient is retired in favor of the primary
   green-700 button. API unchanged. */
function FawnButtonMini({ pf1, buttonText }) {
  const handleButtonClick = (event) => {
    event.preventDefault();
    pf1(event);
  };

  return (
    <div style={{ textAlign: "center" }}>
      <button className="fawn-button-legacy-primary" onClick={(event) => handleButtonClick(event)}>
        {buttonText}
      </button>
    </div>
  );
}

export default FawnButtonMini;
